import { Sidebar, Content } from './layout/';

function App() {
	return (
    <main className='main'>
      <Sidebar />
      <Content />
    </main>
	);
}

export default App;
